<div
  class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
>
  <h4
    class="gw-text-xl gw-font-semibold gw-text-text-primary"
    id="modal-basic-title"
  >
    {{ 'features.integrations.configureCredentials' | translate }}
  </h4>
</div>
<div class="gw-p-6">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="gw-space-y-4">
    <div class="gw-mb-5">
      <label for="sandbox" class="gw-block gw-text-sm gw-font-medium">
        {{ 'features.integrations.sandboxMode' | translate }}
      </label>
      <input id="sandbox" type="checkbox" formControlName="sandbox" />
    </div>
    <!-- pixKey -->
    <fieldset [formGroupName]="'in'" class="gw-space-y-4">
      <legend class="gw-block gw-text-sm gw-font-medium gw-text-text-primary">
        {{ 'features.integrations.cashIn' | translate }}
      </legend>

      <div class="gw-mb-4">
        <label
          for="pixKey"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.pixKey' | translate }}
        </label>
        <input
          id="pixKey"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="pixKey"
          [placeholder]="'features.integrations.pixKeyPlaceholder' | translate"
        />
        <small
          *ngIf="
            form.get('in')?.get('pixKey')?.invalid &&
            form.get('in')?.get('pixKey')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.pixKeyRequired' | translate }}
        </small>
      </div>

      <!-- clientKey (string) -->
      <div class="gw-mb-4">
        <label
          for="clientKey"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.clientKey' | translate }}
        </label>
        <input
          id="clientKey"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="clientKey"
          [placeholder]="
            'features.integrations.clientKeyPlaceholder' | translate
          "
          autocomplete="off"
        />
        <small
          *ngIf="
            form.get('in')?.get('clientKey')?.invalid &&
            form.get('in')?.get('clientKey')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.clientKeyRequired' | translate }}
        </small>
      </div>

      <!-- clientSecret (string) -->
      <div class="gw-mb-4">
        <label
          for="clientSecret"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.clientSecret' | translate }}
        </label>
        <div class="gw-relative">
          <input
            id="clientSecret"
            [type]="showSecret ? 'text' : 'password'"
            class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
            formControlName="clientSecret"
            [placeholder]="
              'features.integrations.clientSecretPlaceholder' | translate
            "
            autocomplete="off"
          />
          <button
            type="button"
            class="gw-absolute gw-right-2 gw-top-2 gw-p-1 gw-text-text-secondary hover:gw-text-text-primary"
            (click)="showSecret = !showSecret"
          >
            <gatewee-icon
              [icon]="showSecret ? '@tui.eye-off' : '@tui.eye'"
              size="16px"
            ></gatewee-icon>
          </button>
        </div>
        <small
          *ngIf="
            form.get('in')?.get('clientSecret')?.invalid &&
            form.get('in')?.get('clientSecret')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.clientSecretRequired' | translate }}
        </small>
      </div>

      <hr class="gw-my-4 gw-border-border-normal" />

      <!-- mtlsCert (file) -->
      <div class="gw-mb-4">
        <label
          for="mtlsCertFile"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsCert' | translate }}
        </label>
        <input
          id="mtlsCertFile"
          type="file"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          (change)="onFileChange($event, 'mtlsCert')"
          accept=".pem,.crt,.cer,.txt"
        />
        <small
          class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block"
          *ngIf="fileNames.mtlsCert"
        >
          {{ 'features.integrations.selected' | translate }}:
          {{ fileNames.mtlsCert }}
        </small>
        <small
          *ngIf="
            form.get('in')?.get('mtlsCert')?.invalid &&
            form.get('in')?.get('mtlsCert')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.mtlsCertRequired' | translate }}
        </small>
      </div>

      <!-- mtlsKey (file) -->
      <div class="gw-mb-4">
        <label
          for="mtlsKeyFile"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsKey' | translate }}
        </label>
        <input
          id="mtlsKeyFile"
          type="file"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          (change)="onFileChange($event, 'mtlsKey')"
          accept=".key,.pem,.txt"
        />
        <small
          class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block"
          *ngIf="fileNames.mtlsKey"
        >
          {{ 'features.integrations.selected' | translate }}:
          {{ fileNames.mtlsKey }}
        </small>
        <small
          *ngIf="
            form.get('in')?.get('mtlsKey')?.invalid &&
            form.get('in')?.get('mtlsKey')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.mtlsKeyRequired' | translate }}
        </small>
      </div>
    </fieldset>

    <fieldset class="gw-mt-4" [formGroupName]="'out'">
      <legend
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-4"
      >
        {{ 'features.integrations.cashOut' | translate }}
      </legend>
      <!-- clientKey (string) -->
      <div class="gw-mb-4">
        <label
          for="outClientKey"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.clientKey' | translate }}
        </label>
        <input
          id="outClientKey"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="clientKey"
          [placeholder]="
            'features.integrations.clientKeyPlaceholder' | translate
          "
          autocomplete="off"
        />
        <small
          *ngIf="
            form.get('out')?.get('clientKey')?.invalid &&
            form.get('out')?.get('clientKey')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.clientKeyRequired' | translate }}
        </small>
      </div>

      <!-- clientSecret (string) -->
      <div class="gw-mb-4">
        <label
          for="outClientSecret"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.clientSecret' | translate }}
        </label>
        <div class="gw-relative">
          <input
            id="outClientSecret"
            [type]="showSecret ? 'text' : 'password'"
            class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
            formControlName="clientSecret"
            [placeholder]="
              'features.integrations.clientSecretPlaceholder' | translate
            "
            autocomplete="off"
          />
          <button
            type="button"
            class="gw-absolute gw-right-2 gw-top-2 gw-p-1 gw-text-text-secondary hover:gw-text-text-primary"
            (click)="showSecret = !showSecret"
          >
            <gatewee-icon
              [icon]="showSecret ? '@tui.eye-off' : '@tui.eye'"
              size="16px"
            ></gatewee-icon>
          </button>
        </div>

        <small
          *ngIf="
            form.get('out')?.get('clientSecret')?.invalid &&
            form.get('out')?.get('clientSecret')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.clientSecretRequired' | translate }}
        </small>
      </div>
    </fieldset>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        [title]="'common.actions.cancel' | translate"
        variant="secondary"
        (click)="close()"
      ></gatewee-button>
      <gatewee-button
        [title]="
          submitting
            ? ('common.actions.saving' | translate)
            : ('common.actions.save' | translate)
        "
        variant="primary"
        type="submit"
        [disabled]="form.invalid || submitting"
      ></gatewee-button>
    </div>
  </form>
</div>
